const KIND_TO_PANE = {
    event_reminder: 'event',
    event_rsvp_requested: 'event',
    event_rsvp_received: 'event',
    expense_added: 'expense',
    todo_assigned: 'todo',
    todo_completed: 'todo',
    // Pas de pane dédié "membres" (V1) : on ramène sur l'accueil du groupe,
    // comme tout kind sans navigation ciblée.
    member_removed: 'home',
};
/**
 * Traduit un kind de notification vers le pane de navigation in-app à ouvrir
 * lors d'un clic (notif in-app ou push). `KIND_TO_PANE` est exhaustif sur
 * `NotificationKind`, mais le fallback `'home'` reste nécessaire en défense :
 * un payload push arrivant hors process (service worker, kind ajouté au
 * schéma sans mise à jour de ce module) n'est pas garanti par le typage.
 */
export function notificationKindToPane(kind) {
    return KIND_TO_PANE[kind] ?? 'home';
}
//# sourceMappingURL=notifications.js.map